import { z } from "zod";
import { IdSchema, IsoDateTimeSchema } from "./common.js";
import { PERMISSIONS } from "../constants/index.js";

/**
 * 진실의 원천: harness/API-SPEC.md §1, harness/SECURITY.md
 */

export const LoginRequestSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type LoginRequest = z.infer<typeof LoginRequestSchema>;

export const SessionUserSchema = z.object({
  id: IdSchema,
  email: z.string().email(),
  name: z.string(),
  permissions: z.array(z.enum(PERMISSIONS)),
  scopes: z.array(
    z.object({
      scope_type: z.enum(["company", "case_status", "all"]),
      scope_value: z.string().nullable(),
    }),
  ),
  session_expires_at: IsoDateTimeSchema,
});
export type SessionUser = z.infer<typeof SessionUserSchema>;
